export const TOOL_LABELS = {
  cursor: 'Cursor (选择工具)',
  pencil: 'Pencil (绘制工具)',
};

export const CLIPBOARD_MENU_LABELS = {
  copy: 'Copy (复制)',
  paste: 'Paste at Playhead (在播放头位置粘贴)',
};

export const preservePastedBlockCompletion = block => ({
  ...block,
  formData: {
    ...(block.formData || {}),
  },
});

export const PASTE_CHOICES = [
  {
    id: 'blocks-only',
    label: 'Paste Annotation Blocks Only (仅粘贴标注方块)',
    title: { english: 'Paste Annotation Blocks Only', chinese: '仅粘贴标注方块' },
    description: {
      english: 'Copies the blocks’ positions, durations, and spacing. Annotation contents are left empty.',
      chinese: '仅复制方块的位置、时长和间距，标注内容留空。',
    },
  },
  {
    id: 'with-contents',
    label: 'Paste Annotation Blocks with Contents (粘贴标注方块及其内容)',
    title: { english: 'Paste Annotation Blocks with Contents', chinese: '粘贴标注方块及其内容' },
    description: {
      english: 'Also copies all annotation contents.',
      chinese: '同时复制所有标注内容。',
    },
  },
];

const PASTE_ERRORS = {
  collision: {
    english: 'Cannot paste because the blocks would overlap existing annotations on this track.',
    chinese: '无法粘贴：标注方块会与此轨道上的现有标注重叠。',
  },
  'sheet-boundary': {
    english: 'Cannot paste because the blocks would extend beyond the end of the annotation sheet.',
    chinese: '无法粘贴：标注方块将超出标注表的结束位置。',
  },
  'invalid-clipboard': {
    english: 'The copied blocks are no longer available. Please copy them again.',
    chinese: '复制的标注方块已失效，请重新复制。',
  },
  'grid-mismatch': {
    english: 'Cannot paste because this position cannot preserve the blocks’ exact durations and spacing on the current time grid.',
    chinese: '无法粘贴：当前位置无法在当前时间网格中完整保留方块的时长和间距。',
  },
};

export const getPasteErrorCopy = reason => (
  PASTE_ERRORS[reason] || PASTE_ERRORS['invalid-clipboard']
);
